var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 31.5,
    height: 31.5,
    rx: 15.75,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4995 16C23.4995 16.1658 23.4337 16.3247 23.3165 16.442C23.1992 16.5592 23.0403 16.625 22.8745 16.625H10.6331L15.1917 21.1828C15.2498 21.2409 15.2958 21.3098 15.3273 21.3857C15.3587 21.4616 15.3749 21.5429 15.3749 21.625C15.3749 21.7071 15.3587 21.7885 15.3273 21.8643C15.2958 21.9402 15.2498 22.0091 15.1917 22.0672C15.1336 22.1253 15.0647 22.1713 14.9888 22.2028C14.913 22.2342 14.8316 22.2504 14.7495 22.2504C14.6674 22.2504 14.5861 22.2342 14.5102 22.2028C14.4343 22.1713 14.3654 22.1253 14.3073 22.0672L8.68233 16.4422C8.62422 16.3842 8.57812 16.3152 8.54667 16.2393C8.51521 16.1635 8.49902 16.0821 8.49902 16C8.49902 15.9179 8.51521 15.8365 8.54667 15.7607C8.57812 15.6848 8.62422 15.6159 8.68233 15.5578L14.3073 9.93282C14.4246 9.81555 14.5837 9.74966 14.7495 9.74966C14.9154 9.74966 15.0744 9.81555 15.1917 9.93282C15.309 10.0501 15.3749 10.2092 15.3749 10.375C15.3749 10.5409 15.309 10.6999 15.1917 10.8172L10.6331 15.375H22.8745C23.0403 15.375 23.1992 15.4409 23.3165 15.5581C23.4337 15.6753 23.4995 15.8343 23.4995 16Z",
    fill: "#162031"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 31.5,
    height: 31.5,
    rx: 15.75,
    stroke: "#E8EAED",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.1917294f.svg";
export { ForwardRef as ReactComponent };